import { type UseMutationOptions, useMutation } from '@tanstack/react-query'
import {
	type BulkPresignedExperienceShellPhotosResponse,
	type HttpStorePresignBulkExperienceShellPhotosOptions,
	httpStorePresignBulkExperienceShellPhotos
} from '@/features/experience-shell/http/experience-shell.http.ts'
import { MUTATION_KEYS } from '@/query-client'

export const useBulkPresignedExperienceShellPhotos = ({
	urlParams,
	options
}: {
	urlParams: HttpStorePresignBulkExperienceShellPhotosOptions['urlParams']
	options?: UseMutationOptions<
		BulkPresignedExperienceShellPhotosResponse,
		unknown,
		Omit<
			HttpStorePresignBulkExperienceShellPhotosOptions['payload'],
			'mutationFn'
		>
	>
}) => {
	return useMutation({
		mutationKey: [
			MUTATION_KEYS.EXPERIENCES_SHELL_PHOTO_PRESIGNED,
			urlParams
		],
		mutationFn: (payload) =>
			httpStorePresignBulkExperienceShellPhotos({ urlParams, payload }),
		...options,
		onSuccess: (data, variables, onMutateResult, context) => {
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
